import { Dispatch, SetStateAction, useEffect } from "react"
import { FormControl, FormHelperText, TextField } from "@mui/material"
import {TestResultForm, TestResultFormErrors } from "../../types"

type SampleNumberField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
  formErrors: TestResultFormErrors,
  setFormErrors: Dispatch<SetStateAction<TestResultFormErrors>>,
}

const SampleNumberField = (props: SampleNumberField) => {
  const { formData, setFormData, formErrors, setFormErrors } = props

  const handleChange = (value: string) => {
    const nextForm = structuredClone(formData)

    const sampleNumber = Number.isFinite(Number(value))
      ? Number(value)
      : null

    nextForm.sample_number = sampleNumber

    setFormData(nextForm)
  }

  useEffect(() => {
    const nextErrors = structuredClone(formErrors)

    const isValidNumber = Number.isFinite(Number(formData.sample_number))
    const hasError = Boolean(formData.sample_number) && !isValidNumber

    nextErrors.sample_number = hasError

    setFormErrors(nextErrors)
  }, [formData.sample_number])

  const label = 'Sample Number'
  const value = formData.sample_number ?? ''
  const placeholder = 'Optional'
  const hasError = formErrors.sample_number

  return (
    <FormControl fullWidth size="small">
      <TextField
        size="small"
        label={label}
        onChange={(event) => handleChange(event.target.value)}
        value={value}
        placeholder={placeholder}
        error={hasError}
        type='number'
      />
      {
        hasError && (
          <FormHelperText error>
            Sample Number must be a number
          </FormHelperText>
        )
      }      
    </FormControl>
  )
}

export default SampleNumberField
